import { Icon } from "@iconify/react";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import styleVariables from "../style_setup";

const styles = createUseStyles({
  Failure: {
    padding: "0 5vw",
    textAlign: "center",
    width: "100vw",
    height: "100vh",
    display: "grid",
    justifyItems: "center",
    alignContent: "center",
    color: "black",
    "& h1": {
      fontSize: "2rem",
      marginBottom: "1rem",
    },
  },
  icon: {
    fontSize: styleVariables.navbarHeight,
    color: "red",
  },
  [`@media ${styleVariables.media.smallscreen}`]: {},
});
export const Failure = ({ headerMsg, message }) => {
  const classes = styles({});

  return (
    <div className={classes.Failure}>
      <h1> {headerMsg ?? "Something went wrong!"} </h1>
      <Icon icon="ic:baseline-error" className={classes.icon} />
      <h2>{message ?? "Please contact the administrator!"}</h2>
    </div>
  );
};
Failure.propTypes = {
  headerMsg: PropTypes.string,
  message: PropTypes.string,
};
